import React from "react";
import moment from "moment";
import ReactDatePicker from "react-datepicker";

function SelectDateRangeDropdown(props) {
  return (
    <>
		<ReactDatePicker
			dateFormat="dd/MM/yyyy"
			selected={props.dateFrom}
			onChange={(date) =>
				props.setDateFrom(date)
			}
			placeholderText={props.placeholderTextfrom}
		/>
		<ReactDatePicker
					dateFormat="dd/MM/yyyy"
					selected={props.dateTo}
			onChange={(date) =>
			props.setDateTo(date)
			}
			placeholderText={props.placeholderTextTo}
		/>
	</>
  )
}

export default SelectDateRangeDropdown;
